import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  ThreadsShareButton,
  ThreadsIcon,
} from "react-share";
import Cross from "../assets/images/svgs/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../redux/store";
import { initiateDeposit } from "../services/depositApi";
import { initiateWithdrawal } from "../services/withdrawalApi";
import { signout } from "../redux/slices/auth/signoutSlice";
import { deleteCookies, setCookies } from "../helper/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import { getRedirectResult } from "firebase/auth";
import { auth } from "../firebase";
import registrationCancel from "../assets/images/bet-frenzy/registration-cancel-warning.svg";
import { TextInput, MobileInput } from "../components";
import {
  changePinValidation,
  forgetPasswordValidation,
  loginValidation,
  signupValidation,
} from "../validation/signup";

import { login } from "../redux/slices/auth/loginSlice";
import { forgotPassword } from "../redux/slices/auth/forgotPasswordSlice";
import { config } from "../redux/slices/auth/configSlice";
import { rakebackBadges } from "../redux/slices/rakeback/badgesDataSlice";
import Logo from "../assets/images/bet-frenzy/Betfrenzy Logo Transparent.png";
import MFAImage from "../assets/images/svgs/totp-icon.svg";
import { signup } from "../redux/slices/auth/signupSlice";
import PinInput from "./pin-input";
import { changePIN } from "../redux/slices/profile/changePINSlice";
import Alert from "../assets/images/bet-frenzy/alert.png";
import backIcon from "../assets/images/bet-frenzy/icons/auth/back.svg";
import copyIcon from "../assets/images/bet-frenzy/icons/copy.svg";
import pastIcon from "../assets/images/bet-frenzy/icons/paste.svg";
import promotionImage from "../assets/images/bet-frenzy/dummy-banner.jpg";
import rack1 from "../assets/images/svgs/object2 1.svg";
import rack2 from "../assets/images/svgs/download.svg";
import upArrow from "../assets/images/svgs/up-arrow.svg";
import { set } from "date-fns";

export const Modal = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const configData = useSelector((state) => state.config.data);

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Mission.subText`)}</span>
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={() => {
                setOpen(!open);
              }}
            >
              {t("Mission.ok")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LocationBlockedModal = ({ open, onClick, message }) => {
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{message}</span>
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={onClick}
            >
              Ok
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LocationAllowModal = ({ open, onRetry }) => {
  const { t } = useTranslation();
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Location.enableLocation`)}</span>
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={onRetry}
            >
              {t("Location.retry")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LogoutModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);

    try {
      const res = await dispatch(signout()).unwrap();

      if (res.status) toast.success(res.message);

      deleteCookies("betfrenzy_token");
      dispatch({ type: "RESET_STATE" });

      persistor.purge();

      const domain = process.env.REACT_APP_FRONT_URL;
      const vpnToken = localStorage.getItem("vpnToken");
      await dispatch(config({ domain, vpnToken })).unwrap();

      sessionStorage.clear();
      localStorage.clear();

      setOpen(false);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div
            className={`${
              window.innerWidth > 1024
                ? "modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2"
                : "modal-body p-1 pt-3 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2"
            }`}
          >
            <div className="pt-2 d-flex align-items-center position-relative mb-3">
              <span className="w-100 text-center fs-20">Signing Out</span>
              <span
                className="svg-icon svg-icon-1 cursor-pointer"
                onClick={() => {
                  setOpen(false);
                }}
                style={{ color: "#fff" }}
              >
                <RxCross2
                  size={25}
                  className="svg-icon cross-icon"
                  // style={{ position: "absolute", right: "25px", top: "25px" }}
                  // onClick={() => {
                  //   setOpen(false);
                  // }}
                />
              </span>
            </div>
            <div className="d-flex justify-content-center">
              <img
                src={Alert}
                width={100}
                height={100}
                alt="logout"
                className="svg-icon svg-icon-2 text-center"
                loading="lazy"
              />
            </div>
            <span className="my-2 fs-16">
              Are you sure you want to continue?
            </span>
            <div className="d-flex flex-wrap justify-content-center flex-column gap-3 mt-4 mb-2">
              <button
                type="submit"
                className={`
             btn-green-faded btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                }}
              >
                <span className="text-black-btn my-0">Return to home page</span>
              </button>

              <button
                type="submit"
                className={`
             btn-purple btn-blue px-3 px-md-5 py-2 btn mx-2 fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
                style={{ background: "#313746", border: "0.9px solid #687594" }}
              >
                {/* <span className="text-white-btn my-0">Continue</span> */}
                <span className="text-white-btn my-0">
                  {isLoggingOut ? "Processing..." : "Continue"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DeleteUserModal = ({ open, setOpen, onClick }) => {
  const { t } = useTranslation();
  const configData = useSelector((state) => state.config.data);

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t("Profile.conformDeleteMsg")}</span>
            <div className="d-flex flex-wrap justify-content-center flex-column gap-3 mt-4 mb-2">
              <button
                type="submit"
                className={`
             btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  onClick();
                }}
              >
                <span className="text-white-btn my-0">{t("Common.yes")}</span>
              </button>
              <button
                type="submit"
                className={`
             btn-purple btn-blue px-3 px-md-5 py-2 btn mx-2 fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                }}
              >
                <span className="text-white-btn my-0">{t("Common.no")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ChangePINModal = ({ open, setOpen, onClick }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    old_pin: "",
    new_pin: "",
    confirm_pin: "",
  });

  const handleChange = (e) => {
    if (e.name == "birthDate") {
      setForm((prev) => ({ ...prev, [e.name]: e.value }));
    } else if (e.name == "isVPNEnabled") {
      setForm((prev) => ({ ...prev, [e.name]: e.checked }));
    } else {
      if (e?.name == "mobile") {
        setForm((prev) => ({ ...prev, [e.name]: e.value }));
        setError((prevState) => ({
          ...prevState,
          [e.name]: "",
        }));
      } else {
        if (typeof e?.preventDefault == "function") {
          e.preventDefault();
        }

        const { name, value } = e.target || e;

        setForm((prev) => ({ ...prev, [name]: value }));
        setError((prevState) => ({
          ...prevState,
          [name]: "",
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = changePinValidation(form);
    if (!isValid) {
      setError(errors);
    } else {
      const payload = {
        old_pin: Number(form.old_pin),
        new_pin: Number(form.new_pin),
        confirm_pin: Number(form.confirm_pin),
      };
      dispatch(changePIN(payload))
        .unwrap()
        .then((res) => {
          if (res.success) {
            setOpen(false);
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
          console.error("Failed :", error);
        });
    }
  };

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "370px", marginLeft: "auto" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setOpen(!open);
                sessionStorage.setItem("fromLogin", "false");
                setForm({
                  old_pin: "",
                  new_pin: "",
                  confirm_pin: "",
                });
              }}
              style={{
                right: "20px",
                top: "20px",
                position: "absolute",
              }}
            >
              <RxCross2
                size={25}
                className="svg-icon cross-icon"
                style={{ position: "absolute", right: "0px", top: "0px" }}
              />
            </span>
            <form className="mt-5 px-3">
              <PinInput
                name={"old_pin"}
                // title={"PIN"} // optional
                value={form.old_pin}
                error={error.old_pin}
                handleChange={handleChange}
                placeholder={"Enter Old PIN"}
              />
              <PinInput
                name={"new_pin"}
                // title={"PIN"} // optional
                value={form.new_pin}
                error={error.new_pin}
                handleChange={handleChange}
                placeholder={"Enter new PIN"}
              />
              <PinInput
                name={"confirm_pin"}
                // title={"PIN"} // optional
                value={form.confirm_pin}
                error={error.confirm_pin}
                handleChange={handleChange}
                placeholder={"Enter confirm PIN"}
              />
            </form>
            <div className="d-flex flex-wrap justify-content-center flex-column gap-3 mt-1 mb-2">
              <button
                type="submit"
                className={`
             btn-green-faded text-black-btn px-3 px-md-5 py-2 mx-3 btn fw-semibold`}
                onClick={(e) => {
                  // e.preventDefault();
                  handleSubmit(e);
                }}
              >
                <span className="text-black-btn my-0">Change PIN</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const RakebackModal = ({ open, setOpen, onClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [left, setLeft] = useState(`0%`);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setIsLoading(true);
    dispatch(rakebackBadges())
      .unwrap()
      .then((res) => {
        if (res.status == 200) {
          setData(res.data);
          setLeft(
            `${
              (res.data?.coins * 100) / res.data?.range?.highestTo[0]?.to_range
            }%`
          );
          setIsLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        setIsLoading(false);
      });
  };
  const handleSubmit = (e) => {};
  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          maxWidth:
            window.innerWidth > 1750
              ? "20%"
              : window.innerWidth > 1350
              ? "30%"
              : window.innerWidth < 1024
              ? "100%"
              : "20%",
          marginLeft: window.innerWidth <= 768 ? "auto" : "46%",
        }}
      >
        <div className="modal-content modal-content-bg h-100 w-80 rack-back-modal-custom">
          <div
            className="modal-body px-0 p-md-1 text-center text-white fw-semibold scroll-y m-1 m-md-2 "
            style={{ padding: "15px 0px" }}
          >
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setOpen(!open);
                sessionStorage.setItem("fromLogin", "false");
              }}
            >
              <RxCross2
                size={25}
                className="svg-icon cross-icon"
                style={{ position: "absolute", right: "22px", top: "22px" }}
              />
            </span>
            <span
              className="my-2 mt-3 fs-24 text-purple justify-content-center align-items-center"
              style={{
                fontFamily: "Poppins",
                fontWeight: 900,
                color: "#aa80f9",
              }}
            >
              <img
                draggable="false"
                src={rack1}
                width={40}
                height={40}
                alt="rack1"
                loading="lazy"
              />
              Rakeback
              <img
                draggable="false"
                src={rack2}
                width={40}
                height={40}
                alt="rack2"
                loading="lazy"
              />
            </span>
            <span className="my-2 fs-12">
              Your VIP Level:{" "}
              <span className="color-00e864 level-card-header">
                {data && data?.current_badge?.name}
              </span>
            </span>
            <div className="level-card">
              {isLoading ? (
                <div className="text-center  py-4 border-bottom-0">
                  <div class="spinner-border text-success " role="status"></div>
                </div>
              ) : (
                <div className="level-progress">
                  <div className="level-labels">
                    <span className="color-00e864">
                      {data && data.range?.lowestFrom[0]?.from_range} PTS
                    </span>
                    <span className="color-00e864">
                      {" "}
                      {data && data.range?.highestTo[0]?.to_range} PTS
                    </span>
                  </div>

                  <div className="progress-bar-container">
                    <div
                      className="progress-value overflow-hidden"
                      style={{
                        width: `${
                          (data?.coins * 100) /
                          data?.range?.highestTo[0]?.to_range
                        }%`,
                      }}
                    >
                      <span
                        className="progress-circle"
                        // style={{
                        //   left: `calc(${left} + 10px)`,
                        // }}
                      >
                        {data && data?.coins}
                      </span>
                    </div>
                  </div>
                  <div className="level-names">
                    <span className="text-white">
                      {data && data.range?.lowestFrom[0]?.name}
                    </span>
                    <span className="text-white">
                      {data && data.range?.highestTo[0]?.name}
                    </span>
                  </div>
                </div>
              )}

              <div className="stats-card">
                <div className="stat-item">
                  <span>Actual Point</span>
                  <span className="stat-value color-00e864">
                    {data && data?.coins}
                  </span>
                </div>
                <div className="stat-item">
                  <span>Total Amount</span>
                  <span className="stat-value color-00e864">0 USD</span>
                </div>
                <div className="stat-item">
                  <span>Min. Rakeback Points</span>
                  <span className="stat-value color-00e864">0</span>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center flex-column gap-3 mt-1 mb-2">
              <button
                type="submit"
                className={`
                  btn-green px-3 px-md-5 py-2 mx-3 btn fw-semibold`}
                onClick={(e) => {
                  handleSubmit(e);
                }}
                style={{ color: "#000" }}
              >
                <span
                  className="text-black-btn my-0 fs-12"
                  style={{ color: "#000 !important" }}
                >
                  Cashout
                </span>
              </button>
              <span
                className="my-2 d-flex justify-content-center align-items-center fs-12 cursor-pointer"
                onClick={() => navigate("/rakeback-vip-club")}
              >
                More Info
                <img
                  src={upArrow}
                  className="rotate-90 mx-2"
                  alt="arrow"
                  width={10}
                  height={10}
                  loading="lazy"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const GameModel = ({ open, setOpen }) => {
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ minWidth: "90%", maxHeight: "80vh", height: "100%" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img
                  draggable="false"
                  loading="lazy"
                  src={Cross}
                  className="svg-icon"
                />
              </span>
            </div>
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            {/* <ReloadIframeTwice /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReloadIframeTwice = () => {
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const first = setTimeout(() => setReloadKey(1), 1000);
    const second = setTimeout(() => setReloadKey(2), 3000);

    return () => {
      clearTimeout(first);
      clearTimeout(second);
    };
  }, []);

  return (
    <iframe
      key={reloadKey}
      src="https://kenof.staging-server.in/"
      title="Iframe Proxy"
      sandbox="allow-scripts allow-same-origin"
      style={{
        border: "none",
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "auto",
      }}
    />
  );
};

export const MaintananceModel = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Sidebar.maintananceText`)}</span>

            <div className="d-flex flex-wrap justify-content-center mt-4 mb-2">
              <button
                type="submit"
                className={`
           btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <span className="text-white-btn my-0">{t("Mission.ok")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ShareModal = ({ refercode, open, setOpen }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const shareUrl = `https://betfrenzy-front.staging-server.in/signup?refercode=${refercode}`;
  const title = "Check out this awesome site!";
  const configData = useSelector((state) => state.config.data);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2 sec
      setOpen(!open);
    } catch (err) {
      console.error("Failed to copy!", err);
      setOpen(!open);
    }
  };

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "450px", marginLeft: "46%" }}
      >
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-25 pt-2"
              style={{ width: "auto" }}
              loading="lazy"
            />
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <RxCross2
                size={25}
                color="white"
                className="svg-icon cross-icon"
                style={{ position: "absolute", right: "25px", top: "25px" }}
              />
            </span>
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2 pt-0 pt-md-0">
            <span className="my-2 fs-20">{t("ReferralEarning.subTitle")}</span>
            <div className="d-flex text-center m-auto my-2 mt-0">
              <div className="p-2 m-1  rounded-2 cursor-pointer">
                <FacebookShareButton url={shareUrl} quote={title}>
                  <FacebookIcon size={25} round iconFillColor="white" />
                </FacebookShareButton>
              </div>

              <div className="p-2 m-1  rounded-2 cursor-pointer">
                <TwitterShareButton url={shareUrl} quote={title}>
                  <TwitterIcon size={25} round iconFillColor="white" />
                </TwitterShareButton>
              </div>
              <div className="p-2 m-1  rounded-2 cursor-pointer">
                <WhatsappShareButton
                  url={shareUrl}
                  quote={title}
                  className="white-icon"
                >
                  <WhatsappIcon
                    size={25}
                    round
                    iconFillColor="white"
                    color="white"
                  />
                </WhatsappShareButton>
              </div>
              <div className="p-2 m-1 rounded-2 cursor-pointer">
                <ThreadsShareButton
                  url={shareUrl}
                  quote={title}
                  className="white-icon"
                >
                  <ThreadsIcon
                    size={25}
                    round
                    iconFillColor="white"
                    color="white"
                  />
                </ThreadsShareButton>
              </div>
            </div>

            <div className=" d-block  w-auto">
              <input
                type="text"
                className=" fs-14 form-control w-100 bg-grey border-0 text-white"
                value={shareUrl}
                disabled={true}
                onChange={(e) => {
                  e.preventDefault();
                }}
              />

              <button
                type="submit"
                className={` box-purple d-flex m-auto my-2 px-4 py-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleCopy();
                }}
              >
                <span className=" my-0 fs-14">
                  {t("ReferralEarning.copyLink")}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InactiveModal = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const configData = useSelector((state) => state.config.data);

  const handleLogout = () => {
    deleteCookies("betfrenzy_token");
    dispatch({ type: "RESET_STATE" });
    setOpen(false);

    persistor.purge();

    sessionStorage.clear();
    localStorage.clear();
    window.location.reload("/");
  };

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
              loading="lazy"
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t("Sidebar.inactive")}</span>
            <div className="d-flex flex-wrap justify-content-center mt-4 mb-2">
              <button
                type="submit"
                className={`
             btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <span className="text-white-btn my-0">{t("Mission.ok")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoginModal = ({
  open,
  setOpen,
  switchToSignup,
  openForgotPINModal,
  onLoginSuccess,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.data);
  const [error, setError] = useState({});

  const [form, setForm] = useState({
    contact: "",
    // agentCode: "",
    // referralCode: "",
    // email: "",
    pin: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prevent multiple clicks
    if (isSubmitting) return;

    const { errors, isValid } = loginValidation(form);

    if (!isValid) {
      setError(errors);
      return;
    }

    setIsSubmitting(true);

    dispatch(login(form))
      .unwrap()
      .then((res) => {
        if (res.success) {
          setCookies("betfrenzy_token", res.token);
          setOpen(false);
          sessionStorage.setItem("fromLogin", "false");
          if (onLoginSuccess) {
            onLoginSuccess();
          }
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.error("Login failed:", error);
        // toast.error(error?.message || "Something went wrong");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    } else {
      const { name, value } = e;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
  };

  useEffect(() => {
    const fetchRedirectResult = async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result) {
          const user = result.user;

          const idToken = await user.getIdToken();
        }
      } catch (error) {
        console.error("Apple Redirect Error:", error);
      }
    };

    fetchRedirectResult();
  }, []);

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered mt-0"
        style={{ maxWidth: window.innerWidth > 1024 ? "40%" : "100%" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-0">
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setOpen(!open);
                sessionStorage.setItem("fromLogin", "false");
                setForm({
                  contact: "",
                  pin: "",
                });
              }}
            >
              <RxCross2
                size={25}
                className="svg-icon cross-icon"
                style={{ position: "absolute", right: "25px", top: "25px" }}
              />
            </span>
            <div className="p-2 p-md-0">
              <div id="recaptcha-container"></div>

              <div
                className={`row signup-height 
           border-radius-40`}
                style={{ borderRadius: "60px" }}
              >
                <div
                  className={`col-12 col-md-6  order-2 order-md-1 margin-15
                              shadow bg-white p-4 m-0 align-content-center 
                              border-radius-40 bg-purple-dark h-md-auto auth-image-section`}
                  style={{ borderRadius: "1.5rem", marginLeft: "15px" }}
                ></div>
                <div
                  className="col order-1 order-md-2  mb-0 flex-grow-1 p-4 text-center pt-0 pb-0 "
                  style={{ height: "fit-content" }}
                >
                  <div className="col-12 mx-auto">
                    <div className="d-flex justify-content-start mb-4">
                      <div className="px-4 py-2 ps-0 cursor-pointer fw-bold text-white fs-12">
                        {t("SignUpPage.login")}
                      </div>
                      <div
                        className="px-4 py-2 ps-0 cursor-pointer text-muted fw-normal fs-12"
                        onClick={() => {
                          setOpen(false);
                          switchToSignup();
                        }}
                      >
                        Sign Up
                      </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <MobileInput
                        name={"contact"}
                        // title={t("SignUpPage.phoneNumber")}
                        value={form.contact}
                        error={error.contact}
                        handleChange={handleChange}
                        placeholder={t("Placeholder.phone")}
                        page={"login"}
                        open={open}
                      />

                      <PinInput
                        name={"pin"}
                        // title={"PIN"} // optional
                        value={form.pin}
                        error={error.pin}
                        handleChange={handleChange}
                        placeholder={"Enter PIN"}
                      />
                      <span
                        className="cursor-pointer text-purple fw-normal d-flex"
                        style={{ color: "#f7904e", fontSize: ".8125rem" }}
                        onClick={() => {
                          openForgotPINModal();
                        }}
                      >
                        Forgot your PIN?
                      </span>

                      <div className="mt-3 mb-5">
                        <div className="my-2 mb-2 ">
                          <button
                            type="submit"
                            className="btn-green-faded btn-purple-shadow btn col-12 py-2 fw-semibold"
                            // onClick={handleSubmit}
                            disabled={isSubmitting}
                          >
                            <span className="text-black-btn">
                              {isSubmitting ? "Logging in..." : "Log In"}
                            </span>
                          </button>
                        </div>

                        <span className=" ps-2 fs-11 form-label color-6b7a99">
                          Don't you have an account?
                          <span
                            style={{ color: "#fff !important" }}
                            className="cursor-pointer text-white fs-11  fw-semibold ps-1"
                            onClick={() => {
                              switchToSignup();
                            }}
                          >
                            Sign Up
                          </span>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SignupModal = ({
  open,
  setOpen,
  switchToLogin,
  onSignupSuccess,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const configData = useSelector((state) => state.config.data);
  const [error, setError] = useState({});
  const { t } = useTranslation();
  const [signUpConfirmModal, setSignUpConfirmModal] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const refercode = queryParams.get("refercode");

  const [form, setForm] = useState({
    contact: "",
    referralCode: refercode,
    pin: "",
    agentCode: "",
  });

  useEffect(() => {
    if (configData) {
      setForm((prev) => ({ ...prev }));
    }
  }, [configData]);

  const signUpclose = () => {
    setOpen(!open);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = signupValidation(form);

    if (!isValid) {
      setError(errors);
      return;
    }
    const payload = {
      ...form,
      agentCode: form.agentCode ? form.agentCode : configData?.agentCode || "",
      // birthDate: formatDate(form.birthDate),
      // agentCode:
      //   form.agentCode
      //     ? form.agentCode
      //     : configData?.agentCode,
    };
    if (!isSubmitting) {
      setIsSubmitting(true);
      dispatch(signup(payload))
        .unwrap()
        .then((res) => {
          if (res.success) {
            setOpen(!open);
            if (onSignupSuccess) {
              onSignupSuccess();
            } else if (location.pathname !== "/") {
              navigate("/");
            } else {
              switchToLogin();
            }
            setForm({
              contact: "",
              referralCode: "",
              pin: "",
            });
          }
        })
        .catch((error) => {
          console.error("Failed :", error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const handleChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    } else {
      const { name, value } = e;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
  };

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered mt-0"
        style={{ maxWidth: window.innerWidth > 1024 ? "40%" : "100%" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-0">
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setSignUpConfirmModal(true);
              }}
            >
              <RxCross2
                size={25}
                className="svg-icon cross-icon"
                style={{ position: "absolute", right: "25px", top: "25px" }}
              />
            </span>
            <div className="p-2 p-md-0">
              <div id="recaptcha-container"></div>

              <div
                className={`row p-2 signup-height 
           border-radius-40 mt-3 mb-3`}
                style={{ borderRadius: "60px" }}
              >
                <div
                  className={`col-12 col-md-6 order-2 order-md-1 
                        shadow bg-white p-4 m-0 align-content-center signup-height
                        border-radius-40 bg-purple-dark-signUp h-md-auto auth-image-section`}
                  style={{ borderRadius: "1.5rem" }}
                ></div>
                <div
                  className="col order-1 order-md-2  mb-0 flex-grow-1 p-4 text-center pt-0 pb-0  "
                  style={{ height: "fit-content" }}
                >
                  <div className="col-12 mx-auto">
                    <div className="d-flex justify-content-start mb-4">
                      <div
                        className="px-4 py-2 ps-0 cursor-pointer text-muted fw-normal"
                        onClick={() => {
                          setOpen(false);
                          switchToLogin();
                        }}
                      >
                        {t("SignUpPage.login")}
                      </div>
                      <div className="px-4 py-2 ps-0 cursor-pointer fw-bold text-white">
                        Sign Up
                      </div>
                    </div>

                    <form>
                      <MobileInput
                        name={"contact"}
                        // title={t("SignUpPage.phoneNumber")}
                        value={form.contact}
                        error={error.contact}
                        handleChange={handleChange}
                        placeholder={t("Placeholder.phone")}
                        page={"signup"}
                        open={open}
                      />

                      <PinInput
                        name={"pin"}
                        // title={"PIN"} // optional
                        value={form.pin}
                        error={error.pin}
                        handleChange={handleChange}
                        placeholder={"Enter PIN"}
                      />

                      <TextInput
                        style={{
                          borderRadius: "30px",
                          marginTop: "5px",
                          background: "#3f3f3f",
                        }}
                        name={"referralCode"}
                        // title={t("SignUpPage.referralCode")}
                        type={"text"}
                        value={form.referralCode}
                        // error={error.referralCode}
                        handleChange={handleChange}
                        placeholder={t("Placeholder.referralCode")}
                        // page={"signup"}
                      />
                      <div className="text-center text-muted fw-semibold">
                        OR
                      </div>
                      <TextInput
                        style={{
                          borderRadius: "30px",
                          marginTop: "5px",
                          background: "#3f3f3f",
                        }}
                        name={"agentCode"}
                        type={"text"}
                        value={form.agentCode}
                        error={error.agentCode}
                        handleChange={handleChange}
                        placeholder={
                          t("Enter Agent Code") || "Enter Agent Code"
                        }
                      />

                      <div className="w-100 mb-2 ">
                        <button
                          type="submit"
                          className="btn-green-faded btn-purple-shadow btn col-12 py-2 fw-semibold"
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                        >
                          <span className="text-black-btn">
                            {isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                ></span>
                                {t("registering") || "Registering..."}
                              </>
                            ) : (
                              t("register") || "Register"
                            )}
                          </span>
                        </button>
                      </div>

                      <span className=" ps-2 fs-12 mt-2 form-label color-6b7a99">
                        Do you have an account?
                        <span
                          className="cursor-pointer fs-12 text-white fw-semibold ps-1"
                          onClick={() => {
                            switchToLogin();
                          }}
                        >
                          Login
                        </span>
                      </span>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SignUpConfirmModal
        open={signUpConfirmModal}
        setOpen={setSignUpConfirmModal}
        signUpclose={signUpclose}
      />
    </div>
  );
};

export const SignUpConfirmModal = ({ open, setOpen, signUpclose }) => {
  const navigate = useNavigate();
  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered mt-0"
        style={{
          maxWidth: window.innerWidth > 1024 ? "25%" : "100%",
          marginLeft: window.innerWidth > 1024 ? "43%" : "",
        }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <div className="d-flex align-items-center position-relative mb-3">
              <span className="w-100 text-center fs-16 mt-3 p-md-2 p-2">
                Are you sure you want to cancel?
              </span>
              <button
                type="button"
                className="btn-close ms-2 btn-close-white position-absolute btn-singup-close end-0 me-n1 me-sm-n2  cross-icon"
                aria-label="Close"
                onClick={() => {
                  setOpen(false);
                  signUpclose();
                }}
                style={{
                  fontSize: "0.9rem",
                  top: "60%",
                  transform: "translateY(-150%)",
                }}
              ></button>
            </div>
            <div className="d-flex justify-content-center">
              <im
                src={registrationCancel}
                width={100}
                height={100}
                alt="logout"
                className="svg-icon svg-icon-2 text-center"
                loading="lazy"
              />
            </div>
            <span className="my-2 fs-12 " style={{ fontWeight: "100" }}>
              Complete registration and claim your welcome bonus
            </span>
            <div className="d-flex flex-wrap justify-content-center flex-column gap-3 mt-1 mb-2">
              <button
                type="submit"
                className={`
             btn-green-faded btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                }}
                style={{
                  color: "#000",
                }}
              >
                <span className="text-black-btn my-0">
                  Back to registration
                </span>
              </button>
              <button
                type="submit"
                className={`
             btn-purple btn-blue px-3 px-md-5 py-2 btn mx-2 fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  // handleLogout();
                  navigate("/");
                  setOpen(false);
                  signUpclose();
                }}
                style={{ background: "#313746", border: "0.9px solid #687594" }}
              >
                <span className="text-white-btn my-0">Cancel</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ForgotPINModal = ({ open, setOpen, openLoginModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    contact: "",
  });

  const handleSubmit = (e) => {
    const { errors, isValid } = forgetPasswordValidation(form);
    if (!isValid) {
      setError(errors);
    } else {
      dispatch(forgotPassword(form))
        .unwrap()
        .then((res) => {
          setForm({
            contact: "",
          });
          setOpen();
        })
        .catch((error) => {
          console.error("Failed to fetch user:", error);
        });
    }
  };

  const handleChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    } else {
      const { name, value } = e;
      setForm((prev) => ({ ...prev, [name]: value }));
      setError((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
  };

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered forgot-pin-modal"
        style={{ maxWidth: "320px", marginTop: "3%" }}
      >
        <div className="modal-content modal-content-bg h-100 custom-reset-pim-modal ">
          <div className="modal-body p-1 p-md-2 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                openLoginModal();
                sessionStorage.setItem("fromLogin", "false");
                setForm({
                  contact: "",
                });
              }}
            >
              <img
                src={backIcon}
                width={30}
                className="svg-icon"
                style={{ position: "absolute", left: "20px", top: "35px" }}
                loading="lazy"
              />
            </span>
            <div className="">
              <div id="recaptcha-container"></div>

              <div
                className={`row p-2 signup-height 
           border-radius-40`}
                style={{ borderRadius: "60px" }}
              >
                <div className={``} style={{ borderRadius: "50px" }}></div>
                <div className="col order-1 order-md-2 mt-4 mb-2 flex-grow-1 text-center">
                  <div className="col-12 mx-auto">
                    <h2 className=" hero-heading-reset-pin">Reset PIN</h2>
                    <p className="hero-heading-input-text-reset-pin">
                      Enter Mobile
                    </p>

                    <div className="text-center mt-4 hero-heading-input-reset-pin">
                      <MobileInput
                        name={"contact"}
                        // title={t("SignUpPage.phoneNumber")}
                        value={form.contact}
                        error={error.contact}
                        handleChange={handleChange}
                        placeholder={t("Placeholder.phone")}
                        // page={"login"}
                        open={open}
                      />
                    </div>

                    <div className="w-100 my-2 ">
                      <button
                        type="submit"
                        className="btn-green-faded btn-purple-shadow btn col-12 fw-semibold"
                        onClick={(e) => {
                          handleSubmit(e);
                        }}
                      >
                        <span className=" text-black-btn">
                          Send Instructions
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const WalletModal = ({
  open,
  setOpen,
  mfaOpen,
  setmfaOpen,
  tab,
  isPromo = false,
  promotionId = "",
}) => {
  const [activeTab, setActiveTab] = useState("Deposit");
  const [activeSubTab, setActiveSubTab] = useState("Local Currency");
  const { error: profileError, data: profileData } = useSelector(
    (state) => state.getProfile
  );

  const tabOptions = ["Deposit", "Withdrawal"]; //  "Buy Crypto",
  const subOptions = ["Local Currency"]; // "Crypto"

  const showSubTabs = activeTab === "Deposit" || activeTab === "Withdraw";
  const [paymentMode, setPaymentMode] = useState("");
  const [amount, setAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([
    {
      value: "ORANM",
      label: "ORANM",
    },
    {
      value: "MTN",
      label: "MTN",
    },
  ]);

  const [subOptionsArray, setSubOptionsArray] = useState([
    {
      value: "Bitcoin",
      label: "Bitcoin",
    },
    {
      value: "Ripple",
      label: "Ripple",
    },
  ]);

  const [buyCryptoArray, setbuyCryptoArray] = useState([
    {
      value: "Swapped",
      label: "Swapped",
    },
    {
      value: "MoonPay",
      label: "MoonPay",
    },
  ]);

  const [validationError, setValidationError] = useState("");

  const validateInput = () => {
    // Validate payment mode
    if (!paymentMode || paymentMode.trim() === "") {
      setValidationError("Payment mode is required");
      return false;
    }

    // Validate amount
    if (!amount || amount.trim() === "") {
      setValidationError("Amount is required");
      return false;
    }

    const amountNum = Number(amount);
    if (isNaN(amountNum)) {
      setValidationError("Amount must be a valid number");
      return false;
    }

    if (amountNum <= 0) {
      setValidationError("Amount must be greater than 0");
      return false;
    }

    if (amountNum < 100) {
      setValidationError("Minimum amount is 100");
      return false;
    }

    setValidationError("");
    return true;
  };

  const enableMFA = () => {
    setmfaOpen(true);
  };

  const handleDeposit = async () => {
    if (
      profileData?.user?.is_kyc_verified == "not_submitted" ||
      profileData?.user?.is_kyc_verified == "rejected" ||
      profileData?.user?.is_kyc_verified == "submitted"
    ) {
      toast.error(
        "Please complete account verification to access wallet features."
      );
      return;
    }
    if (!validateInput()) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await initiateDeposit({
        amount: Number(amount),
        mode: paymentMode,
        is_promo: isPromo,
        promotion_id: promotionId,
      });
      if (response?.success !== true || response?.status !== 200) {
        throw new Error("Failed to initiate deposit.");
      }
      toast.success(
        "Deposit initiated successfully. Please check your mobile payment app."
      );
      setOpen(false);
      setPaymentMode("");
      setAmount("");
      setValidationError("");

      // if (response?.payment_url) {
      //   // Redirect to payment URL
      //   window.open(response.payment_url, '_blank');
      //   setOpen(false);
      //   setPaymentMode('');
      //   setAmount('');
      //   setValidationError('');
      // } else {
      //   toast.error('Failed to initiate deposit. No payment URL received.');
      // }
    } catch (error) {
      console.error("Deposit error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to initiate deposit. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleWithdraw = async () => {
    if (
      profileData?.user?.is_kyc_verified == "not_submitted" ||
      profileData?.user?.is_kyc_verified == "rejected" ||
      profileData?.user?.is_kyc_verified == "submitted"
    ) {
      toast.error(
        "Please complete account verification to access wallet features."
      );
      return;
    }

    if (!validateInput()) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await initiateWithdrawal({
        amount: Number(amount),
        mode: paymentMode,
      });

      if (response?.status) {
        // Show success message
        toast.success(
          "Withdrawal request submitted successfully. Transaction ID: " +
            (response?.transaction_id || "N/A")
        );
        setOpen(false);
        setPaymentMode("");
        setAmount("");
        setValidationError("");
      } else {
        toast.error("Failed to process withdrawal.");
      }
    } catch (error) {
      console.error("Withdrawal error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to process withdrawal. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // const enableMFA = () => {
  //   setmfaOpen(true);
  // };
  // useEffect(() => {
  //   const tabActive = tab === null ? "deposit" : tab;
  //   setActiveTab(tabActive);
  // }, [tab]);
  return (
    <>
      <div
        className={open ? "modal d-block show-animate" : "modal"}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog custom-modal" role="document">
          <div
            className="modal-content"
            style={{
              backgroundColor: "rgba(27, 31, 46, .9)",
              borderRadius: "16px",
              border: "solid 0.0625rem #464b58b4",
              overflow: "hidden",
              width: window.innerWidth > 1024 ? "90%" : "100%",
            }}
          >
            <div
              className="modal-body p-3  text-white fw-semibold"
              style={{
                background: "rgba(27,31,46,.9) !important",
                height: "100%",
              }}
            >
              <div className={`position-relative pt-5 mb-3`}>
                <div
                  className={`d-flex flex-wrap justify-content-center gap-2 ${
                    window.innerWidth > 1024 ? "" : "mt-4"
                  }`}
                >
                  {tabOptions.map((tab) => (
                    <div key={tab} className="position-relative">
                      {tab == "buy-crypto" && (
                        <span
                          className="badge position-absolute"
                          style={{
                            top: "-12px",
                            right: "1px",
                            fontSize: "0.5rem",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            backgroundColor: "#ff0000",
                            animation: "fadeInOut 1s infinite",
                          }}
                        >
                          0% Fee
                        </span>
                      )}

                      <button
                        className={`btn-no-hover ${
                          activeTab == tab
                            ? "btn-green-faded border-0"
                            : "btn-outline-light border-CCD6F6"
                        } px-4 rounded-pill fs-11`}
                        onClick={() => {
                          setActiveTab(tab);
                          if (tab == "buy-crypto") {
                            setActiveSubTab("");
                          } else {
                            setActiveSubTab("Local Currency");
                          }

                          if (tab == "deposit") {
                            setOptions([
                              {
                                value: "ORANM",
                                label: "ORANM",
                              },
                              {
                                value: "MTN",
                                label: "MTN",
                              },
                            ]);
                          } else if (tab === "withdraw") {
                            setOptions([
                              { value: "ORANGE", label: "ORANGE" },
                              { value: "MTN", label: "MTN" },
                            ]);
                          }
                        }}
                      >
                        {tab}
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <span
                className="svg-icon svg-icon-1 cursor-pointer m-1"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <RxCross2
                  size={25}
                  className="svg-icon cross-icon"
                  style={{ position: "absolute", right: "20px", top: "20px" }}
                />
              </span>
              {showSubTabs && (
                <div
                  className={`d-flex justify-content-center gap-2 mb-4 ${
                    window.innerWidth < 768 ? "flex-column" : ""
                  }`}
                >
                  {subOptions.map((sub) => (
                    <button
                      key={sub}
                      className={`btn-no-hover ${
                        activeSubTab == sub
                          ? "btn-dark btn-wallet-selected"
                          : "btn-dark border-CCD6F6"
                      } px-4 rounded-pill fs-11`}
                      style={{
                        minHeight: "40px",
                      }}
                      onClick={() => setActiveSubTab(sub)}
                    >
                      {sub}
                    </button>
                  ))}
                </div>
              )}
              <div className="mb-2">
                {activeTab != "" &&
                  activeTab != "buy-crypto" &&
                  activeSubTab != "Crypto" && (
                    <div className="mx-4 my-auto">
                      <label className="d-block fw-normal mb-2 fs-12 text-muted">
                        Payments
                      </label>
                      <select
                        name="type"
                        value={paymentMode}
                        aria-label="Type"
                        data-placeholder="Activity Type"
                        className="form-select select-lng-extra-h pe-5 cursor-pointer custom-arrow mb-3 custom-green-select"
                        onChange={(e) => {
                          setPaymentMode(e.target.value);
                          setValidationError("");
                        }}
                        style={{
                          borderColor: validationError?.includes("Payment mode")
                            ? "#ff6b6b"
                            : "#464b58",
                        }}
                      >
                        <option value="">Select Mode</option>
                        {options?.map((item, index) => (
                          <option key={index} value={item.value}>
                            <b>{item.label}</b>
                          </option>
                        ))}
                      </select>
                      {validationError?.includes("Payment mode") && (
                        <span className="d-block fs-12 text-danger mb-2">
                          {validationError}
                        </span>
                      )}
                    </div>
                  )}
              </div>
              {activeTab != "buy-crypto" &&
                activeSubTab != "Crypto" &&
                paymentMode && (
                  <div className="mb-4">
                    <div className="mx-4 my-auto">
                      <label className="d-block fw-normal mb-2 fs-12 text-muted">
                        Amount ( Minimum 100 )
                      </label>
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => {
                          setAmount(e.target.value);
                          setValidationError("");
                        }}
                        placeholder="Enter amount"
                        className="form-control select-lng-extra-h pe-5 mb-1"
                        style={{
                          background: "#0b121e",
                          color: "#CCD6F6",
                          border: validationError?.includes("Amount")
                            ? "1px solid #ff6b6b"
                            : "1px solid #464b58",
                          height: "40px",
                        }}
                        min={100}
                      />
                      {validationError?.includes("Amount") && (
                        <span className="d-block fs-12 text-danger mb-2">
                          {validationError}
                        </span>
                      )}
                    </div>
                  </div>
                )}

              {activeTab != "buy-crypto" && activeSubTab == "Crypto" && (
                <div className="mx-4 my-auto">
                  <label className="d-block mb-1 fs-11 fw-normal text-muted">
                    Account Currency
                  </label>
                  <select
                    name="type"
                    value=""
                    aria-label="Type"
                    data-placeholder="Activity Type"
                    className="form-select select-lng-extra-h pe-5 cursor-pointer custom-arrow mb-3 custom-green-select"
                  >
                    <option value={"fw-normal"}>Account Currency</option>
                    {subOptionsArray?.map((item, index) => (
                      <option
                        key={index}
                        value={item.value}
                        onClick={(e) => {}}
                      >
                        <b>{item.label}</b>
                      </option>
                    ))}
                  </select>

                  <label className="d-block mb-1 fs-11 fw-normal text-muted">
                    Choose Network
                  </label>
                  <select
                    name="type"
                    value=""
                    aria-label="Type"
                    data-placeholder="Activity Type"
                    className="form-select select-lng-extra-h pe-5 cursor-pointer custom-arrow mb-3 custom-green-select"
                  >
                    <option value={""}>
                      <b>Choose network</b>
                    </option>
                    {[]?.map((item, index) => (
                      <option
                        key={index}
                        value={item?.value}
                        onClick={(e) => {}}
                      >
                        <b>{item?.label}</b>
                      </option>
                    ))}
                  </select>
                  {activeTab == "Deposit" && (
                    <>
                      <label className="d-block mb-1 fs-11 text-muted">
                        Deposit Address
                      </label>
                      <div className="input-with-icon secret-key-input mb-3">
                        <input
                          type="text"
                          placeholder="Wallet Address"
                          className="form-control form-control-sm deposit-input"
                          value={""}
                          readOnly
                        />
                        <img
                          src={copyIcon}
                          alt="Copy"
                          className="copy-icon"
                          onClick={() => navigator.clipboard.writeText("")}
                          title="Copy to clipboard"
                          loading="lazy"
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
              {activeTab == "buy-crypto" && (
                <>
                  <div className="mx-4 my-auto">
                    <label className="d-block mb-1 fw-normal fs-11 text-muted">
                      Choose payment method
                    </label>
                    <select
                      name={"type"}
                      value={""}
                      aria-label={`Type`}
                      data-placeholder={`Activity Type`}
                      style={{
                        background: "#242836 !important",
                      }}
                      className="form-select select-lng-extra-h pe-5  cursor-pointer custom-arrow mb-3  custom-green-select"
                    >
                      <option value={""}>
                        <b>Choose payment method</b>
                      </option>
                      {buyCryptoArray?.map((item, index) => (
                        <option
                          key={index}
                          value={item?.value}
                          onClick={(e) => {}}
                        >
                          <b>{item?.label}</b>
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mx-4 my-auto">
                    <div>
                      <label className="d-block fw-normal mb-2 fs-12 text-muted">
                        Amount
                      </label>
                    </div>

                    <div className="d-flex amount-input">
                      <input
                        type="text"
                        value=""
                        className="mb-3 w-75 "
                        style={{
                          marginRight: "5px",
                          borderRadius: "5px !important",
                          background: "#242836 !important",
                        }}
                      />
                      <select
                        name={"type"}
                        value={""}
                        aria-label={`Type`}
                        data-placeholder={`Activity Type`}
                        style={{
                          borderRadius: "5px !important",
                          background: "#242836 !important",
                        }}
                        className="form-select select-lng-extra-h pe-5 cursor-pointer custom-arrow custom-arrow-coin w-25 mb-3  custom-green-select"
                      >
                        <option value={""}>INR</option>
                        {[{ value: "INR", label: "INR" }]?.map(
                          (item, index) => (
                            <option
                              key={index}
                              value={item?.value}
                              onClick={(e) => {}}
                              className="d-flex"
                              style={{
                                backgroundSize: "1rem",
                                background: `url("data:image/svg+xml;utf8,<svg height='18px' width='18px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><circle cx='12' cy='12' r='11' fill='%23006400'/><text x='12' y='16' font-size='14' text-anchor='middle' fill='white' font-family='Arial'>₹</text></svg>") no-repeat right 1.5rem center`,
                              }}
                            >
                              <b>{item?.label}</b>
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {activeTab == "buy-crypto" && (
                <div className="d-flex justify-content-center mt-2 mb-3">
                  <button
                    className="rounded-pill px-5 py-2 fs-12 w-75"
                    style={{
                      background: "rgba(40,45,57,.7)",
                      color: "#CCD6F6",
                      border: "2px solid #00ec66 !important",
                      boxShadow: "0 0 0 1px #00ec66",
                    }}
                  >
                    Deposit
                  </button>
                </div>
              )}

              {activeTab == "buy-crypto" && (
                <>
                  <div className="mx-4 my-auto my-2">
                    <div className="crypto-item fw-normal fs-10 my-1">
                      Funds deposited will be credited to your default wallet
                    </div>
                    <div className="crypto-item fw-normal fs-10 my-1">
                      Deposits are accepted without any fees
                    </div>
                    <div className="crypto-item fw-normal fs-10 my-1">
                      Minimum deposit - $8 equivalent of every available
                      currency
                    </div>
                  </div>
                </>
              )}

              {activeTab != "buy-crypto" && (
                <div className="d-flex flex-column justify-content-center mb-5 align-items-center">
                  {validationError && !paymentMode && (
                    <span className="d-block fs-12 text-danger mb-2 text-center">
                      {validationError}
                    </span>
                  )}
                  <button
                    className="d-flex wallet-btn  box-green-faded justify-content-center w-75 rounded-pill mb-2 fw-bold border-0 py-2 fs-12  h-40px align-items-center"
                    style={{
                      color: "black",
                      fontWeight: "bolder",
                      opacity: isLoading || !paymentMode || !amount ? 0.5 : 1,
                      cursor:
                        isLoading || !paymentMode || !amount
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={
                      activeTab === "Deposit" ? handleDeposit : handleWithdraw
                    }
                    disabled={isLoading || !paymentMode || !amount}
                  >
                    {isLoading ? "Processing..." : "Confirm"}
                  </button>
                </div>
              )}
            </div>
            <div
              className="pt-3 text-center"
              style={{
                backgroundColor: "#242735",
                borderTop: "1px solid #333",
                paddingBottom: "1rem",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                marginTop: "auto",
              }}
            >
              <p className="text-muted fs-10 mb-2 fw-normal">
                Improve your account security with Two-Factor Authentication
              </p>
              <button
                className="rounded-pill px-10 py-2 mx-4 fs-12 btn-outline-light w-200px h-50-px"
                style={{
                  backgroundColor: "#313746",
                  color: "#fff",
                  border: "1px solid #687594",
                }}
                onClick={enableMFA}
              >
                Enable 2FA
              </button>
            </div>
          </div>
        </div>
      </div>
      {mfaOpen && (
        <MFAModal open={mfaOpen} setmfaOpen={setmfaOpen} fromDirect={false} />
      )}
    </>
  );
};
export const MFAModal = ({ open, setOpen, fromDirect }) => {
  return (
    <>
      <div
        className={open ? "modal mfa-modal d-block show-animate" : "modal"}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog custom-MFA-modal" role="document">
          <div
            className="modal-content"
            style={{
              backgroundColor: "rgba(24, 26, 32, 0.9)",
              borderRadius: "16px",
              border: "1px solid #444",
              overflow: "hidden",
              width: window.innerWidth > 1500 ? "80%" : "100%",
              left: window.innerWidth > 1024 ? (fromDirect ? "0%" : "30%") : "",
            }}
          >
            <div
              className="modal-body p-3 mx-3 text-white fw-semibold"
              style={{
                background: "rgba(27,31,46,.9) !important",
              }}
            >
              <div className="position-relative text-center mt-1">
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <img
                    src={MFAImage}
                    alt=""
                    className="w-8 d-flex m-auto auth-image"
                    loading="lazy"
                  />
                </div>
                <h5 className="fw-bold fs-12 mb-1 mt-2 color-CCD6F6">
                  Enable 2FA
                </h5>
              </div>

              <span
                className="svg-icon svg-icon-1 cursor-pointer"
                onClick={() => {
                  setOpen(false);
                }}
                style={{ color: "#fff" }}
              >
                <RxCross2
                  size={25}
                  className="svg-icon cross-icon"
                  style={{ position: "absolute", right: "25px", top: "25px" }}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </span>
              <hr
                style={{
                  borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                  margin: "0 0 1rem 0",
                }}
              />

              <p
                className="text-muted fw-normal fs-12 text-center mb-0 p-2 color-97a1c2"
                style={{ fontWeight: 400 }}
              >
                Improve your account security and protect it from unauthorized
                access
              </p>
              <div className="text-center mb-3">
                <p
                  className="fs-12 fw-normal mb-2 color-CCD6F6"
                  style={{ fontWeight: 600 }}
                >
                  Scan the QR code with Google Authenticator App
                </p>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    backgroundColor: "rgba(255,255,255,0.05)",
                    borderRadius: "8px",
                    margin: "0 auto",
                  }}
                ></div>
              </div>
              <div className="mb-3 px-2 secret-key-input">
                <p
                  className="fs-12 mb-2 fw-normal color-CCD6F6"
                  style={{ fontWeight: 600 }}
                >
                  Or enter the secret key manually
                </p>

                <div className="input-with-icon secret-key-input">
                  <input
                    type="text"
                    placeholder="Secret Key"
                    className="form-control form-control-sm"
                    value={""}
                    readOnly
                  />
                  <img
                    src={copyIcon}
                    alt="Copy"
                    className="copy-icon"
                    onClick={() => navigator.clipboard.writeText("")}
                    title="Copy to clipboard"
                    loading="lazy"
                  />
                </div>
              </div>
              <hr
                style={{
                  borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                  margin: "0 0 1rem 0",
                }}
              />
              <div className="mb-3 mt-1 px-2 secret-key-input">
                <p className="fs-10 fw-normal mb-2 text-muted color-97a1c2">
                  Account Password
                </p>
                <input
                  type="password"
                  placeholder="Enter your account password"
                  className="form-control form-control-sm"
                  style={{
                    backgroundColor: "#1b1f2e",
                    border: "1px solid #444",
                    color: "#fff",
                  }}
                />
              </div>

              <div className="mb-3 px-2">
                <div className="d-flex align-items-center mb-2">
                  <label className="fs-10 fw-normal text-muted color-97a1c2 m-0">
                    6-Digit Verification Code
                  </label>

                  <div className="divider"></div>

                  <div className="paste-pill">
                    Paste
                    <img
                      loading="lazy"
                      src={pastIcon}
                      alt="Paste"
                      className="paste-icon"
                    />
                  </div>
                </div>

                <div className="d-flex px-2 justify-content-center">
                  {[...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "rgba(255,255,255,0.05)",
                        borderRadius: "5px",
                        margin: "0 3px",
                        border: ".0667rem solid #47495f",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const ReadMorePromotion = ({
  open,
  setOpen,
  promo,
  profileData,
  setIsWalletOpen,
  setLoginOpen,
  handleGameClick,
  setLoginMode,
  setSignupOpen,
}) => {
  const navigate = useNavigate();

  return (
    <div className={open ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered promo-model"
        style={{ maxWidth: "45%", marginTop: "1%" }}
      >
        <div className="modal-content modal-content-bg h-100 promotion-modal-readmore">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-0">
            <div className="mt-5 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
              <div
                className={`d-flex flex-wrap px-3 align-items-center ${
                  window.innerWidth > 1024
                    ? "justify-content-between"
                    : "justify-content-center"
                }`}
              >
                <div>
                  <span className="w-100 text-center text-uppercase fs-18">
                    {promo?.title}
                  </span>
                </div>
                <div
                  className={`mx-4 ${
                    window.innerWidth > 1024 ? "mt-2" : "my-3"
                  }`}
                >
                  {!profileData?.user ? (
                    <span
                      onClick={() => {
                        setOpen(false);

                        setSignupOpen(true);
                      }}
                      className="box-green-depo text-black text-black-btn fs-12 py-0 px-4 align-self-center cursor-pointer"
                    >
                      Register
                    </span>
                  ) : (
                    promo?.minDeposit > 0 && (
                      <span
                        onClick={() => setIsWalletOpen(true)}
                        className="box-green-depo text-black text-black-btn fs-12 py-0 px-4 align-self-center cursor-pointer"
                      >
                        Deposit
                      </span>
                    )
                  )}
                </div>
              </div>

              <div>
                <span
                  className="svg-icon svg-icon-1 cursor-pointer"
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  <RxCross2
                    size={25}
                    className="svg-icon cross-icon"
                    style={{ position: "absolute", right: "25px", top: "25px" }}
                  />
                </span>
              </div>
            </div>
            <div
              className="mt-3"
              style={{ height: "65vh", width: "100%", overflow: "auto" }}
            >
              <div style={{ height: "200px" }}>
                <img
                  src={promo?.promoBannerUrl || promotionImage}
                  className="my-3 mx-2"
                  style={{
                    borderRadius: "10px",
                    height: "inherit",
                    objectFit: "fill",
                    width: "-webkit-fill-available",
                  }}
                  alt=""
                  loading="lazy"
                />
              </div>
              <div className="mt-5">
                <span>{promo?.description}</span>

                {!promo?.minDeposit > 0 && (
                  <div className="d-flex justify-content-center my-3">
                    {profileData?.user && (
                      <button
                        disabled={promo?.claimed}
                        className="btn btn-success border-0"
                        onClick={() => {
                          if (promo?.bonusType == "free_bet") {
                            handleGameClick();
                          } else {
                            navigate(`/casino-new/${promo?.id}`);
                          }
                        }}
                      >
                        {!promo?.claimed ? "Claim Now" : "Claimed"}
                      </button>
                    )}
                  </div>
                )}

                <div className="p-2 p-sm-2 p-md-3 p-lg-4 p-xl-4 p-md-0 mt-3">
                  <div
                    className="terms-container"
                    dangerouslySetInnerHTML={{
                      __html: promo?.termsAndConditions,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
